module.exports = __webpack_public_path__ + "img/s2-1-ext.c2122259.png";